module.exports = __webpack_public_path__ + "media/images/greennote 5-8fdfff934855044f782516c87c8c7348.svg";